import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { IconsModule } from '@core/icons/icons.module';
import { TranslocoCoreModule } from '@core/transloco/transloco.module';
import { PaginationComponent } from './pagination.component';

@NgModule({
  declarations: [PaginationComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslocoCoreModule,
    MatIconModule,
    IconsModule,
  ],
  exports: [PaginationComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PaginationModule {}
